import {IArenaViewModel} from "../../services/arenas/models/arenas/arena-view-model.interface";
import React from 'react';
import {observer} from "mobx-react";

interface SwiperWindowComponentProps {
    windowPosition: number;
    arena: IArenaViewModel;
}

export const SwiperWindowComponent: React.FC<SwiperWindowComponentProps> = observer((props) => {
    return props.arena.renderList(props.windowPosition);
});


